export default __webpack_public_path__ + "fa2c3e1.png";